var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompany(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#ACBDC5;}\r\n\t.st2{fill:#597380;}\r\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#314A52;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Building"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 27,
    className: "st0",
    width: 22,
    height: 34
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M35,19h-4v5H8v36H6c-1.1,0-2,0.9-2,2v2h44v-3h5V19h-4V7.5l-14,3V19z M32,44V28H12v24c0,2.2,2.7,4,6,4 C25.7,56,32,50.6,32,44z M16,32h4v4h-4V32z M24,32h4v4h-4V32z M16,40h4v4h-4V40z M24,40h4v4h-4V40z M20,48v4h-4v-4H20z M24,48h4v4 h-4V48z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M28,16h12v4h-8v4h-4V16z M52,24H40v4h12V24z M52,32H40v4h12V32z M50,48H40v4h7.2c-4.4,4.9-11.3,8-19.2,8h-4v4 h24v-3h5V40H40v4h11.5C51.2,45.4,50.7,46.7,50,48z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M40,6.4V0h4v5.6L52,4v12h4v44h2c1.1,0,2,0.9,2,2v2H44v-4h8V20h-4V8.9l-12,2.4V16h-4V8L40,6.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/company.bb46e9f8a05f7814b30a4ac610e75383.svg";
export { ForwardRef as ReactComponent };